import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";



export class WorkDeliveryStandardApi extends NewviewOaBaseApi {
  public get ControllerName(): any {
    return 'work-delivery-standard'
  }

}
